import { PropsWithChildren } from 'react';
import { StackProps } from './Stack';

const VStack: React.FunctionComponent<PropsWithChildren<StackProps>> = ({
  children,
  className,
  justifyContent,
  alignItems,
  gap,
  padding,
  margin,
  alignSelf,
  width,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap,
        justifyContent,
        alignItems,
        padding,
        margin,
        alignSelf,
        width,
        maxWidth,
        minWidth,
        height,
        maxHeight,
        minHeight
      }}
    >
      {children}
    </div>
  );
};

export default VStack;
